<template>
  <v-container>
    <Breadcrumbs :crumbs="crumbs" />
    <PageHeader>
      <template v-slot:header>等級評価設定</template>
      <template v-slot:annotation>
        等級ごとの評価データを表示します。該当年度内の評価内容を編集することができます。
      </template>
    </PageHeader>

    <v-row class="text-center px-3">
      <v-col cols="12" md="3">
        <v-select
          label="期間（年度）"
          v-model="period"
          item-text="label"
          item-value="value"
          :items="periodItems"
          dense
          return-object
        />
      </v-col>
      <v-col v-if="isDepartmentActive" cols="12" md="3">
        <v-select
          label="部署"
          v-model="department"
          item-text="label"
          item-value="value"
          :items="departmentItems"
          dense
          return-object
        />
      </v-col>
      <v-col cols="12" md="3">
        <v-select
          label="優先順位"
          v-model="userRank"
          item-text="label"
          item-value="value"
          :items="userRankItems"
          dense
          return-object
        />
      </v-col>
      <v-col cols="4" md="3" lg="2" class="text-left">
        <Button @click="get_goal_grade()" color="primary">検索</Button>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          loading-text="読み込み中..."
          no-data-text="評価データは見つかりませんでした。検索条件を変更して再度検索してください。"
        >
          <template v-slot:[`item.USER_AVATER`]="{ item }">
            <Avatar
              v-if="item.USER_AVATER"
              :src="item.USER_AVATER"
              :size="40"
              class="mr-2"
            />
          </template>
          <template v-slot:[`item.EDIT`]="{ item }">
            <Button
              color="secondary"
              class="mr-1"
              @click="onClickGradeEvaluationDetail(item)"
              :small="true"
              >詳細</Button
            >
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <DialogMessage ref="dialog" />
    <Loader :loading="loading" />
    <ConfirmDialog
      ref="confirm"
      title="スタッフ評価設定"
      :message="confirmMessage"
      buttonMessage="OK"
    />
    <DialogMessageAsync ref="asyncdialog" @confirm="asyncDialogBack">
    </DialogMessageAsync>
  </v-container>
</template>

<script>
import ConfirmDialog from '@/components/Common/ConfirmMessage.vue';
import DialogMessageAsync from '@/components/Common/DialogMessageAsync.vue';
import config from '../../const.js';
import axios from 'axios';
import message from '../../message.js';
import {
  getSessionStorageItem,
  makeDateTimeStr,
  makeSystemDateStr,
} from '@/common.js';
export default {
  components: {
    ConfirmDialog,
    DialogMessageAsync,
  },
  data() {
    return {
      // Breadcrumbs
      crumbs: [
        {
          name: '等級評価設定',
          route: 'GradeEvaluationSetting',
        },
      ],
      userInfo: {},
      loading: false,
      isDepartmentActive: false,
      isEdit: false,
      confirmMessage: null,
      period: {},
      periodItems: [],
      periodIdCookie: '',
      periodIdCookieName: 'periodIdCookie',
      periodNameCookie: '',
      periodNameCookieName: 'periodNameCookie',
      department: {},
      departmentItems: [],
      userRank: {},
      userRankItems: [],
      userNameSearch: '',
      goalId: '',
      userId: '',
      userName: '',
      selectPeriodId: '',
      tmpItems: [],
      items: [],
      headers: [
        {
          text: '部署',
          align: 'left',
          value: 'DEPARTMENT_NAME',
          width: '20%',
        },
        {
          text: '優先順位',
          align: 'left',
          value: 'USER_RANK_NAME',
          width: '20%',
        },
        {
          text: '等級名称',
          align: 'left',
          value: 'GRADE_NAME',
          width: '20%',
        },
        {
          text: '',
          align: '',
          value: 'EDIT',
        },
        {
          text: '',
          align: '',
          value: 'DELETE',
        },
      ],
      periodStatus: '',
      hasPeriod: false,
      initPeriodId: '',
    };
  },
  created() {
    const userInfo = getSessionStorageItem();
    this.userInfo = userInfo;
    if (userInfo) {
      this.userRank = userInfo.USER_RANK;
      if (
        this.userRank == config.USER_RANK_TOP ||
        this.userRank == config.USER_RANK_M ||
        this.userRank == config.USER_RANK_SYSOP
      ) {
        // TopとMとシスオペの場合
        this.isDepartmentActive = true;
      } else {
        // 上記以外
        this.isDepartmentActive = false;
      }
    }
    // ログインユーザーチェック
    this.checkLoginUser();
    // ユーザランク情報の設定
    this.get_userRank();
    // 部署情報の設定
    this.get_department();
    // 期間(年度)の設定
    this.getPeriod();
  },
  methods: {
    onClickGradeEvaluationDetail(item) {
      this.$router.push({
        name: 'GradeEvaluationPartSetting',
        params: {
          goalId: Buffer.from(item.GOAL_ID).toString('base64'),
          gradeId: Buffer.from(item.GRADE_ID).toString('base64'),
          periodId: Buffer.from(this.selectPeriodId).toString('base64'),
        },
      });
    },
    asyncDialogBack() {
      // ログイン画面遷移処理
      this.$router.push({ name: 'Login' });
    },
    async checkLoginUser() {
      // ローディング画像表示
      this.loading = true;

      await axios
        .get(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/login/user/' +
            this.userInfo.SESSION_ID +
            '/' +
            this.userInfo.USER_ID
        )
        .then((response) => {
          // 評価データ取得
          if (response.status == 200) {
            if (response.data[0].USER_RANK != this.userInfo.USER_RANK) {
              var msgStr =
                'Hitonobiを操作しているスタッフ様の等級が変更されています。\n' +
                ' 操作で不具合が発生する可能性があるため、Hitonobiをログアウトします。';
              this.$refs.asyncdialog.open('info', msgStr);
              return;
            }
          }
        })
        .catch((error) => {
          let errStr = '';
          if (error.response.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async get_goal_grade() {
      // ユーザ情報取得
      let userInfo = getSessionStorageItem();

      // セッションチェック
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        return;
      }

      // 期間(年度)チェック
      if (!this.period.value) {
        this.$refs.dialog.open(
          'info',
          '期間(年度)が選択されていません。期間(年度)は必須選択です。'
        );
        return;
      }
      // 期間(年度)
      var periodId = this.period.value;
      this.selectPeriodId = periodId;

      // 部署
      if (this.isDepartmentActive) {
        var departmentKey = this.department.value;
        if (!departmentKey) {
          departmentKey = config.EMPTY_STRING;
        }
      } else {
        departmentKey = userInfo.DEPARTMENT_KEY;
      }

      // ユーザランク
      var userRank = this.userRank.value;
      if (!userRank) {
        userRank = config.EMPTY_STRING;
      }

      // ログインユーザランク
      var loginUserRannk = userInfo.USER_RANK;
      if (userInfo.USER_RANK == config.USER_RANK_SYSOP) {
        // シスオペでログインした場合、TOP権限で検索
        loginUserRannk = config.USER_RANK_TOP;
      }

      let vm = this;
      this.loading = true;

      //----- 目標作成状態チェック
      await axios
        .get(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/Organization/' +
            userInfo.SESSION_ID +
            '/' +
            userInfo.USER_ID +
            '/' +
            userInfo.ORGANIZATION_KEY
        )
        .then((response) => {
          let userMakeStatus = response.data[0].GOAL_MAKE_STATUS;
          if (userMakeStatus == config.EXEC_RUN) {
            // ローディング画像終了
            this.loading = false;

            // 1:実行中の場合は処理終了
            this.$refs.dialog.open('info', message.MSG_BULK_PROGRAM_RUNNING);
            return;
          } else {
            // 目標等級検索処理
            axios
              .get(
                config.CONNECT_EVALUATIONS_URL +
                  '/Evaluations/manages/grade/evaluations/' +
                  userInfo.SESSION_ID +
                  '/' +
                  userInfo.USER_ID +
                  '/' +
                  periodId +
                  '/' +
                  departmentKey +
                  '/' +
                  userRank +
                  '/' +
                  loginUserRannk
              )
              .then((response) => {
                // ローディング画像終了
                this.loading = false;
                // 目標等級データ取得
                vm.items = response.data;
                // 優先順位名称
                for (let i = 0; i < vm.items.length; i++) {
                  if (vm.items[i].USER_RANK == config.USER_RANK_TOP) {
                    vm.items[i].USER_RANK_NAME = this.userInfo.USER_RANK_NAME_1;
                  } else if (vm.items[i].USER_RANK == config.USER_RANK_M) {
                    vm.items[i].USER_RANK_NAME = this.userInfo.USER_RANK_NAME_2;
                  } else if (vm.items[i].USER_RANK == config.USER_RANK_S) {
                    vm.items[i].USER_RANK_NAME = this.userInfo.USER_RANK_NAME_3;
                  } else if (vm.items[i].USER_RANK == config.USER_RANK_J) {
                    vm.items[i].USER_RANK_NAME = this.userInfo.USER_RANK_NAME_4;
                  } else if (vm.items[i].USER_RANK == config.USER_RANK_E) {
                    vm.items[i].USER_RANK_NAME = this.userInfo.USER_RANK_NAME_5;
                  }
                }
              })
              .catch((error) => {
                // ローディング画像終了
                this.loading = false;
                let errStr = '';
                if (error.status == 400) {
                  errStr = message.MSG_ERROR_SESSION + error;
                  this.$refs.dialog.open('error', errStr);
                } else {
                  errStr = message.MSG_ERROR_SYTEM + error;
                  this.$refs.dialog.open('error', errStr);
                }
              });
          }
        })
        .catch((error) => {
          // ローディング画像終了
          this.loading = false;

          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
    },
    async getPeriod() {
      this.loading = true;
      let vm = this;
      await axios
        .get(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/period/' +
            this.userInfo.SESSION_ID +
            '/' +
            this.userInfo.USER_ID +
            '/' +
            this.userInfo.ORGANIZATION_KEY
        )
        .then((response) => {
          // 年度データ取得
          vm.tmpItems = response.data;
          var nowStr = makeSystemDateStr();
          this.hasPeriod = false;
          this.initPeriodId = '';

          for (var i = 0; i < vm.tmpItems.length; i++) {
            var periodStartDate = makeDateTimeStr(
              'S',
              vm.tmpItems[i].PERIOD_START_DATE
            );
            var periodEndDate = makeDateTimeStr(
              'E',
              vm.tmpItems[i].PERIOD_END_DATE
            );
            // 現在日時が年度開始・終了の期間内かを判定
            if (periodStartDate <= nowStr && periodEndDate >= nowStr) {
              //this.hasPeriod = true;
              this.initPeriodId = vm.tmpItems[i].PERIOD_ID;
            }
            var item = {
              label: vm.tmpItems[i].PERIOD_NAME,
              value: vm.tmpItems[i].PERIOD_ID,
            };
            this.periodItems.push(item);
          }

          // ラベル設定
          for (var j = 0; j < vm.tmpItems.length; j++) {
            if (vm.tmpItems[j].PERIOD_ID == this.initPeriodId) {
              this.period.label = vm.tmpItems[j].PERIOD_NAME;
            }
          }

          this.period.value = this.initPeriodId;
        })
        .catch((error) => {
          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        });

      this.loading = false;
    },
    async get_department() {
      // 部署情報取得
      this.loading = true;
      let vm = this;

      await axios
        .get(
          config.CONNECT_URL +
            '/Encouragements/manage/department/' +
            this.userInfo.SESSION_ID +
            '/' +
            this.userInfo.USER_ID +
            '/' +
            this.userInfo.ORGANIZATION_KEY
        )
        .then((response) => {
          // 部署データ取得
          this.departmentItems = [];
          var emptyItem = { label: '', value: '' };
          this.departmentItems.push(emptyItem);
          vm.tmpItems = response.data;
          for (let i = 0; i < vm.tmpItems.length; i++) {
            var item = {
              label: vm.tmpItems[i].DEPARTMENT_NAME,
              value: vm.tmpItems[i].DEPARTMENT_KEY,
            };
            this.departmentItems.push(item);
          }
        })
        .catch((error) => {
          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
      // ローディング画像終了
      this.loading = false;
    },
    async get_userRank() {
      // ローディング画像表示
      this.loading = true;

      var emptyItem = { label: '', value: '' };
      this.userRankItems.push(emptyItem);

      if (
        this.userRank == config.USER_RANK_TOP ||
        this.userRank == config.USER_RANK_SYSOP
      ) {
        // M
        var itemM = {
          label: this.userInfo.USER_RANK_NAME_2,
          value: config.USER_RANK_M,
        };
        this.userRankItems.push(itemM);
        // S
        var itemS = {
          label: this.userInfo.USER_RANK_NAME_3,
          value: config.USER_RANK_S,
        };
        this.userRankItems.push(itemS);
        // J
        var itemJ = {
          label: this.userInfo.USER_RANK_NAME_4,
          value: config.USER_RANK_J,
        };
        this.userRankItems.push(itemJ);
        // E
        var itemE = {
          label: this.userInfo.USER_RANK_NAME_5,
          value: config.USER_RANK_E,
        };
        this.userRankItems.push(itemE);
      } else if (this.userRank == config.USER_RANK_M) {
        // S
        var itemS_M = {
          label: this.userInfo.USER_RANK_NAME_3,
          value: config.USER_RANK_S,
        };
        this.userRankItems.push(itemS_M);
        // J
        var itemJ_M = {
          label: this.userInfo.USER_RANK_NAME_4,
          value: config.USER_RANK_J,
        };
        this.userRankItems.push(itemJ_M);
        // E
        var itemE_M = {
          label: this.userInfo.USER_RANK_NAME_5,
          value: config.USER_RANK_E,
        };
        this.userRankItems.push(itemE_M);
      } else if (this.userRank == config.USER_RANK_S) {
        // J
        var itemJ_S = {
          label: this.userInfo.USER_RANK_NAME_4,
          value: config.USER_RANK_J,
        };
        this.userRankItems.push(itemJ_S);
        // E
        var itemE_S = {
          label: this.userInfo.USER_RANK_NAME_5,
          value: config.USER_RANK_E,
        };
        this.userRankItems.push(itemE_S);
      } else if (this.userRank == config.USER_RANK_J) {
        // E
        var itemE_J = {
          label: this.userInfo.USER_RANK_NAME_5,
          value: config.USER_RANK_E,
        };
        this.userRankItems.push(itemE_J);
      }

      // ローディング画像終了
      this.loading = false;
    },
    closeEdit() {
      this.getPeriod();
    },
    getCookieArray() {
      let arr = new Array();
      if (document.cookie != '') {
        let tmp = document.cookie.split('; ');
        for (let i = 0; i < tmp.length; i++) {
          let data = tmp[i].split('=');
          arr[data[0]] = decodeURIComponent(data[1]);
        }
        if (arr[this.periodIdCookieName] != '') {
          this.periodIdCookie = arr[this.periodIdCookieName];
        }
      }
    },
  },
};
</script>
